import Image from "next/image"

import closeIcon from "@/public/icons/close.svg"
import Style from "@/components/core/SlideDrawer/index.module.scss"

import { useEffect, useRef } from "react"
import {
  getFocusableEls,
  trapTabKey,
  setAriaHidden,
  removeAriaHidden,
} from "@/components/core/SlideDrawer/utils"
import { addAnalyticsCloseSliderProductOnDisplay } from "@/components/ProductDetail/v3/ProductDetailView/ProductOnDisplay/analytics"

const SlideDrawer = props => {
  const { isOpen = false, title = "", subTitle = "", children, onClose } = props

  const drawerRef = useRef(null)

  useEffect(() => {
    if (isOpen) {
      document.querySelector("body").classList.add("drawer-open")
    } else {
      const drawerOpen = document.getElementsByClassName("drawer-open")
      if (drawerOpen.length > 0) {
        addAnalyticsCloseSliderProductOnDisplay()
      }
      document.querySelector("body").classList.remove("drawer-open")
    }
  }, [isOpen])

  useEffect(() => {
    if (!isOpen) return
    const drawer = drawerRef.current
    if (!drawer) return

    let focusableEls = getFocusableEls(drawer)
    if (focusableEls.length > 0) {
      focusableEls[0].focus()
    }

    const handleTrap = e => {
      focusableEls = getFocusableEls(drawer)
      trapTabKey(e, focusableEls, drawer)
    }
    document.addEventListener("keydown", handleTrap, true)

    const observer = new window.MutationObserver(() => {
      focusableEls = getFocusableEls(drawer)
    })
    observer.observe(drawer, { childList: true, subtree: true })

    const toHide = setAriaHidden(drawer, Style.SlideDrawerBackdrop)

    return () => {
      document.removeEventListener("keydown", handleTrap, true)
      observer.disconnect()
      removeAriaHidden(toHide)
    }
  }, [isOpen, children])

  return (
    <>
      {isOpen ? (
        <div className={`${Style.SlideDrawerBackdrop}`} onClick={onClose} />
      ) : null}
      <div
        className={`${Style.SlideDrawer} ${isOpen ? Style.Open : ""}`}
        ref={drawerRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="slide-drawer-title"
        aria-describedby="slide-drawer-subtitle"
      >
        <div className="header">
          <button
            className="close-btn"
            onClick={() => onClose(false)}
            aria-label="Close drawer"
            tabIndex={0}
            type="button"
          >
            <Image
              src={closeIcon}
              height={17}
              width={17}
              alt="Close"
              draggable={false}
            />
          </button>
          <div className="title" id="slide-drawer-title">
            {title}
          </div>
          <div className="sub-title" id="slide-drawer-subtitle">
            {subTitle}
          </div>
        </div>
        {children}
      </div>
    </>
  )
}

export default SlideDrawer
